<template>
    <el-container class="HydropowerExpenseBill" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-header height="80px">
            <el-row>
                <el-col>
                    <h2>其他收费</h2>
                </el-col>
                <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                        placement="bottom-start"
                        width="400"
                        trigger="manual"
                        v-model="visible"
                        popper-class="queryExpenseBill">
                        <el-form :model="form" label-width="80px">
                            <el-form-item label="账单类型" label-width="80px" prop="type">
                                <el-select v-model="form.type" clearable placeholder="请选择账单类型">
                                    <!-- <el-option label="租金" value="租金"></el-option>
                                    <el-option label="物业费" value="物业费"></el-option>
                                    <el-option label="电费" value="电费"></el-option>
                                    <el-option label="水费" value="水费"></el-option>
                                    <el-option label="预约订单" value="预约订单"></el-option> -->
                                    <el-option
                                        v-for="item in TypeList"
                                        :key="item.value"
                                        :label="item.cName"
                                        :value="item.cName"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="公司名称" label-width="80px" prop="company_name">
                                <el-input v-model="form.company_name" placeholder="公司名称"></el-input>
                            </el-form-item>
                            <el-form-item label="账单状态" label-width="80px" prop="status">
                                <el-select v-model="form.status" clearable placeholder="请选择账单状态">
                                    <el-option label="未收费" value="未收费"></el-option>
                                    <el-option label="已收费" value="已收费"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="账单期间" label-width="80px" prop="status">
                                <!-- <el-select v-model="form.status" clearable placeholder="">
                                    <el-option label="未收费" value="未收费"></el-option>
                                    <el-option label="已收费" value="已收费"></el-option>
                                </el-select> -->
                                <el-date-picker v-model="form.yearmonth" type="month" placeholder="选择月" value-format="yyyy-MM">
                                </el-date-picker>
                            </el-form-item>
                        </el-form>
                        <el-row>
                            <el-col style="text-align: right;">
                                <el-button type="primary" @click="Reset">重置</el-button>
                                <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                            </el-col>
                        </el-row>
                        <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                    </el-popover>
                </el-col>
                <el-col :span="12">
                    <!-- <el-dropdown @command="OneTouch" trigger="click">
                        <el-button type="primary">
                            一键生成<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="1">物业费</el-dropdown-item>
                            <el-dropdown-item :command="2">租金</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <el-button type="primary" @click="OneClickTransmission">一键发送</el-button>
                    <el-button type="primary" @click="Export">导出</el-button>
                    <el-button type="primary" @click="ImportExpenseBillShow">导入</el-button>
                    <el-button type="primary" @click="AddExpenseBillShow">新增</el-button>
                    <el-button type="primary" @click="PrintExpenseBill">打印</el-button>
                </el-col>
            </el-row>
        </el-header>
        <el-main>
            <div style="display: none;">
                <ExpenseBillPrint ref="ExpenseBillPrint"></ExpenseBillPrint>
            </div>
            <el-table :data="tableData" :height="Height - 247" border style="width: 100%" @selection-change="handleSelectionChange" :span-method="Merge">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="company_name" label="公司名称" width="200px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="room" label="室号" width="80px">
                </el-table-column>
                <el-table-column prop="is_confirm" label="状态" width="80px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_confirm === 1">已确认</span>
                        <span v-else>未确认</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fee_name" label="费用名称" width="120px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="type" label="费用类型" width="120px">
                </el-table-column>
                <el-table-column prop="create_date" label="制作日期" width="100px">
                </el-table-column>
                <!-- <el-table-column prop="buildding" label="栋号" width="80px">
                </el-table-column> -->
                <el-table-column prop="floor" label="楼层" width="80px">
                </el-table-column>
                <!-- <el-table-column prop="room1" label="车位号" width="100px">
                </el-table-column>
                <el-table-column prop="room2" label="仓库号" width="100px">
                </el-table-column> -->
                <el-table-column prop="qijian" label="费用期间" width="150px">
                </el-table-column>
                <el-table-column prop="sfqj" label="收费期间" width="100px">
                </el-table-column>
                <el-table-column prop="num" label="用量" width="100px">
                </el-table-column>
                <el-table-column prop="beilv" label="倍率" width="100px">
                </el-table-column>
                <el-table-column prop="amount" label="单价" width="100px">
                </el-table-column>
                <el-table-column prop="total" label="价税合计" width="100px">
                </el-table-column>
                <el-table-column prop="before" label="上月量" width="100px">
                </el-table-column>
                <el-table-column prop="after" label="本月量" width="100px">
                </el-table-column>
                <!-- <el-table-column prop="fuwufee" label="配套设施服务费" width="130px">
                </el-table-column> -->
                <el-table-column prop="shou_date" label="收款日期" width="100px">
                    <template slot-scope="scope">
                        <span v-show="scope.row.shou_date !== '0000-00-00'">{{scope.row.shou_date}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="shou_money" label="收款金额" width="100px">
                </el-table-column>
                <el-table-column prop="shou_bank" label="收款银行" width="100px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="bank_name" label="户名" width="100px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="bank_no" label="银行账号" width="100px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="remark" label="备注" width="100px" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="address" label="操作" width="160px" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="EditExpenseBillShow(scope.row)">编辑</el-button>
                        <el-button type="text" @click="ToVoidExpenseBillShow(scope.row)">作废</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog :title="title" :visible.sync="OneTouchExpenseBill" top="7vh" width="500px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="OneTouchExpenseBill" :fullscreen="fullscreen">
                <div slot="title" class="dialog-title" @click.stop>
                    <div class="title">
                        <span>{{title}}</span>
                    </div>
                    <i class="iconfont" @click="fullscreen = !fullscreen" :class="{'icon-quanping1':fullscreen===false, 'icon-tuichuquanping': fullscreen}"></i>
                </div>
                <div :style="fullscreenstyles()" class="ExpenseBillData">
                    <el-form :model="formData" ref="ruleform" :rules="ruleforms" label-width="80px">
                        <el-form-item label="年份" prop="year">
                            <el-date-picker v-model="formData.year" type="year" placeholder="选择年" value-format="yyyy">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="月份" prop="month">
                            <el-select v-model="formData.month" placeholder="请选择月份">
                                <el-option label="1月" :value="1"></el-option>
                                <el-option label="2月" :value="2"></el-option>
                                <el-option label="3月" :value="3"></el-option>
                                <el-option label="4月" :value="4"></el-option>
                                <el-option label="5月" :value="5"></el-option>
                                <el-option label="6月" :value="6"></el-option>
                                <el-option label="7月" :value="7"></el-option>
                                <el-option label="8月" :value="8"></el-option>
                                <el-option label="9月" :value="9"></el-option>
                                <el-option label="10月" :value="10"></el-option>
                                <el-option label="11月" :value="11"></el-option>
                                <el-option label="12月" :value="12"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancelOneTouchExpenseBill">取 消</el-button>
                    <el-button type="primary" @click="confirmOneTouchExpenseBill" :loading="confirmloding">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="titles" :visible.sync="ExpenseBillDialog" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="ExpenseBillDialog" :fullscreen="fullscreens">
                <div slot="title" class="dialog-title" @click.stop>
                    <div class="title">
                        <span>{{titles}}</span>
                    </div>
                    <i class="iconfont" @click="fullscreens = !fullscreens" :class="{'icon-quanping1':fullscreens===false, 'icon-tuichuquanping': fullscreens}"></i>
                </div>
                <div :style="fullscreenstyle()" class="ExpenseBillDialogData">
                    <el-form :model="ExpenseBillformData" ref="ExpenseBillruleform" :rules="ExpenseBillruleforms" label-width="80px">
                        <el-form-item label="费用名称" prop="fee_name">
                            <el-input v-model="ExpenseBillformData.fee_name" placeholder="请输入费用名称"></el-input>
                        </el-form-item>
                        <el-form-item label="费用类型" prop="type">
                            <el-select v-model="ExpenseBillformData.type" placeholder="请选择费用类型">
                                <!-- <el-option label="租金" value="租金"></el-option>
                                <el-option label="物业费" value="物业费"></el-option>
                                <el-option label="电费" value="电费"></el-option>
                                <el-option label="水费" value="水费"></el-option>
                                <el-option label="预约订单" value="预约订单"></el-option> -->
                                <el-option
                                    v-for="item in TypeList"
                                    :key="item.value"
                                    :label="item.cName"
                                    :value="item.cName"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司" prop="company_id">
                            <el-select v-model="ExpenseBillformData.company_id" filterable remote placeholder="请选择公司" :remote-method="remoteMethod" :loading="loading" @change="changecompany" clearable>
                                <el-option v-for="item in CompanyList" :key="item.id" :label="item.title" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item label="栋号" prop="buildding">
                            <el-input v-model="ExpenseBillformData.buildding" placeholder="请输入费用名称"></el-input>
                        </el-form-item> -->
                        <el-form-item label="楼层" prop="floor">
                            <el-input v-model="ExpenseBillformData.floor" placeholder="请输入楼层"></el-input>
                        </el-form-item>
                        <el-form-item label="室号" prop="room">
                            <el-input v-model="ExpenseBillformData.room" placeholder="请输入室号"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="车位号" prop="room1">
                            <el-input v-model="ExpenseBillformData.room1" placeholder="请输入车位号"></el-input>
                        </el-form-item>
                        <el-form-item label="仓库号" prop="room2">
                            <el-input v-model="ExpenseBillformData.room2" placeholder="请输入仓库号"></el-input>
                        </el-form-item> -->
                        <el-form-item label="用量" prop="num">
                            <el-input v-model="ExpenseBillformData.num" placeholder="请输入用量"></el-input>
                        </el-form-item>
                        <el-form-item label="倍率" prop="beilv" class="money">
                            <el-input v-model="ExpenseBillformData.beilv" @input="MoneyInput(ExpenseBillformData.beilv, 'beilv')" placeholder="请输入倍率"></el-input>
                        </el-form-item>
                        <el-form-item label="单价" prop="amount" class="money">
                            <el-input v-model="ExpenseBillformData.amount" @input="MoneyInput(ExpenseBillformData.amount, 'amount')" placeholder="请输入单价"></el-input>
                        </el-form-item>
                        <el-form-item label="价税合计" prop="total" class="money">
                            <el-input v-model="ExpenseBillformData.total" @input="MoneyInput(ExpenseBillformData.total, 'total')" placeholder="请输入总价"></el-input>
                        </el-form-item>
                        <el-form-item label="费用期间" prop="qijian">
                            <el-date-picker v-model="ExpenseBillformData.qijian" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy.MM.dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="收费期间" prop="sfqj">
                            <el-date-picker v-model="ExpenseBillformData.sfqj" type="month" placeholder="请选择收款日期" value-format="yyyy-MM">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="缴费截止日期" prop="shou_date" label-width="110px">
                            <el-date-picker v-model="ExpenseBillformData.jiezhi" type="date" placeholder="请选择缴费截止日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="上月量" prop="before">
                            <el-input v-model="ExpenseBillformData.before" placeholder="请输入上月量"></el-input>
                        </el-form-item>
                        <el-form-item label="本月量" prop="after">
                            <el-input v-model="ExpenseBillformData.after" placeholder="请输入本月量"></el-input>
                        </el-form-item>
                        <el-form-item label="收款日期" prop="shou_date">
                            <el-date-picker v-model="ExpenseBillformData.shou_date" type="date" placeholder="请选择收款日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="收款金额" prop="shou_money" class="money">
                            <el-input v-model="ExpenseBillformData.shou_money" placeholder="请输入收款金额" @input="MoneyInput(ExpenseBillformData.shou_money, 'shou_money')"></el-input>
                        </el-form-item>
                        <el-form-item label="收款银行" prop="shou_bank">
                            <!-- <el-input v-model="ExpenseBillformData.shou_bank" placeholder="请输入收款银行"></el-input> -->
                            <el-select v-model="ExpenseBillformData.shou_bank" placeholder="请选择收款银行" @change="Bankchange">
                                <el-option
                                    v-for="item in BankList"
                                    :key="item.value"
                                    :label="item.name"
                                    :value="item.name"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="户名" prop="bank_name">
                            <!-- <el-input v-model="ExpenseBillformData.shou_bank" placeholder="请输入收款银行"></el-input> -->
                            <el-select v-model="ExpenseBillformData.bank_name" placeholder="请选择户名">
                                <el-option
                                    label="上海东方众鑫投资有限公司"
                                    value="上海东方众鑫投资有限公司"
                                >
                                </el-option>
                                <el-option
                                    label="上海枫蓝物业顾问有限公司"
                                    value="上海枫蓝物业顾问有限公司"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="银行账号" prop="bank_no">
                            <!-- <el-input v-model="ExpenseBillformData.shou_bank" placeholder="请输入收款银行"></el-input> -->
                            <el-select v-model="ExpenseBillformData.bank_no" placeholder="请选择银行账号" @change="Bankchanges">
                                <el-option
                                    v-for="item in BankLists"
                                    :key="item.value"
                                    :label="item.no"
                                    :value="item.no"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark">
                            <el-input type="textarea" v-model="ExpenseBillformData.remark" placeholder="请输入备注"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="发票编号" prop="shou_fapiao">
                            <el-input v-model="ExpenseBillformData.shou_fapiao" placeholder="请输入发票编号"></el-input>
                        </el-form-item> -->
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancelExpenseBill">取 消</el-button>
                    <el-button type="primary" @click="confirmExpenseBill" :loading="Editconfirmloding">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog class="ImportExpenseBilldialog" :title="ImportExpenseBillTitle" :visible.sync="ImportExpenseBilldialog" width="460px">
                <ul style="margin-bottom: 10px;">
                    <li>
                        <span>第一步：请点击下面的链接下载Excel模板，并按照模板填写信息</span>
                        <a href="/ocenter/public/uploads/费用账单模板.xlsx" download="账单管理模板">下载模板</a>
                    </li>
                    <li>
                        <span>第二步：导入Excel模板文件</span>
                        <el-upload
                        class="upload-demo"
                        :action="http + '/report/uplexcel'"
                        :data="Uploaddata"
                        name="excel"
                        :show-file-list="false"
                        accept=".xls,.xlsx,.XLS,.XLSX"
                        :before-upload="BeforeUpload"
                        :on-success="Success">
                            <el-button style="margin: 5px;" type="primary" size="small">{{ImportExpenseBillTitle}}</el-button>
                            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件</div>
                        </el-upload>
                    </li>
                </ul>
            </el-dialog>
        </el-main>
        <el-footer height="40px">
            <el-row>
                <el-col :span="6">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="Size"
                        layout="total"
                        :total="total">
                    </el-pagination>
                </el-col>
                <el-col :span="12" style="text-align: center;">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="Size"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </el-col>
                <el-col :span="6">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="Size"
                        layout="->, sizes"
                        :total="total">
                    </el-pagination>
                </el-col>
            </el-row>
        </el-footer>
    </el-container>
</template>
id int 10 0 0 0 0 0 0  0     -1 0
type varchar 255 0 -1 0 0 0 0  0 费用名称 utf8 utf8_general_ci  0 0
create_date date 0 0 -1 0 0 0 0  0 制作日期    0 0
company_name varchar 255 0 -1 0 0 0 0  0 公司名称 utf8 utf8_general_ci  0 0
buildding varchar 255 0 -1 0 0 0 0  0 栋号 utf8 utf8_general_ci  0 0
floor varchar 255 0 -1 0 0 0 0  0 楼层 utf8 utf8_general_ci  0 0
room varchar 255 0 -1 0 0 0 0  0 室号 utf8 utf8_general_ci  0 0
room1 varchar 255 0 -1 0 0 0 0  0 车位号 utf8 utf8_general_ci  0 0
room2 varchar 255 0 -1 0 0 0 0  0 仓库号 utf8 utf8_general_ci  0 0
qijian varchar 255 0 -1 0 0 0 0  0 费用期间 utf8 utf8_general_ci  0 0
num varchar 255 0 -1 0 0 0 0  0 面积,数量 utf8 utf8_general_ci  0 0
amount varchar 255 0 -1 0 0 0 0  0 单价 utf8 utf8_general_ci  0 0
total varchar 255 0 -1 0 0 0 0  0 总价 utf8 utf8_general_ci  0 0
before varchar 255 0 -1 0 0 0 0  0 上月量 utf8 utf8_general_ci  0 0
after varchar 255 0 -1 0 0 0 0  0 本月量 utf8 utf8_general_ci  0 0
fuwufee varchar 255 0 -1 0 0 0 0  0 配套设施服务费 utf8 utf8_general_ci  0 0
shou_date date 0 0 -1 0 0 0 0  0 收款日期    0 0
shou_money varchar 255 0 -1 0 0 0 0  0 收款金额 utf8 utf8_general_ci  0 0
shou_bank varchar 255 0 -1 0 0 0 0  0 收款银行 utf8 utf8_general_ci  0 0
shou_fapiao varchar 255 0 -1 0 0 0 0  0 发票编号 utf8 utf8_general_ci  0 0
<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
import ExpenseBillPrint from "./ExpenseBillPrint";
export default {
    name: 'ExpenseBill',
    data() {
        return {
            fullscreenLoading: false,
            currentPage: 1,
            Size: 20,
            total: 0,
            visible: false,
            tableData: [],
            title: '',
            OneTouchExpenseBill: false,
            fullscreen: false,
            formData: {},
            ruleforms: {
                year: [
                     { required: true, message: '请选择年份', trigger: 'change' }
                ],
                month: [
                     { required: true, message: '请选择月份', trigger: 'change' }
                ],
            },
            confirmloding: false,
            urls: https.http,
            http: https.https,
            form: {
                type: '',
                company_name: '',
                status: '',
                yearmonth: ''
            },
            fullscreens: false,
            titles: '',
            ExpenseBillDialog: false,
            ExpenseBillformData: {},
            ExpenseBillruleforms: {
                fee_name: [
                    { required: true, message: '请输入费用名称', trigger: 'blur' }
                ],
                type: [
                    { required: true, message: '请选择费用类型', trigger: 'change' }
                ],
                company_id: [
                    { required: true, message: '请选择公司', trigger: 'change' }
                ],
            },
            Editconfirmloding: false,
            CompanyList: [],
            loading: false,
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            ImportExpenseBillTitle: '',
            ImportExpenseBilldialog: false,
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            multipleSelection: [],
            TypeList: [],
            spanArr: [],
            pos: '',
            BankList: [],
            tableDatas: [],
            BankLists: [],
            BankListss: []
        };
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        Bankchange (val) {
            for (let item in this.BankLists) {
                if (this.BankLists[item].name == val) {
                    this.ExpenseBillformData.bank_no = this.BankLists[item].no
                }
            }
        },
        Bankchanges (val) {
            for (let item in this.BankList) {
                if (this.BankList[item].no == val) {
                    this.ExpenseBillformData.shou_bank = this.BankLists[item].name
                }
            }
        },
        PrintExpenseBill () {
            let that = this
            setTimeout(() => {
                this.$print(that.$refs.ExpenseBillPrint.$el)
            }, 500)
            // })
        },
        getSpanArr (data) {
            // 动态合并单元格
            this.spanArr = []
            this.pos = ''
            for (var i = 0; i < data.length; i++) {
                if (i === 0) {
                    this.spanArr.push(1)
                    this.pos = 0
                } else {
                // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
                    if (data[i].iOrder === data[i - 1].iOrder) {
                        this.spanArr[this.pos] += 1
                        this.spanArr.push(0)
                    } else {
                        this.spanArr.push(1)
                        this.pos = i
                    }
                }
            }
        },
        Merge ({ row, column, rowIndex, columnIndex }) {
            // 合并单元格
            if (columnIndex === 0) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 1) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 2) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 3) {
                const _row = this.spanArr[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col
                }
            }
        },
        handleSelectionChange (val) {
            this.multipleSelection = val;
            let that = this
            // that.$refs.ExpenseBillPrint.SetfeeData(JSON.parse(JSON.stringify(data))).then(res => {
            let feeData = []
            let fee_ids = []
            for (let item in that.multipleSelection) {
                if (!fee_ids.includes(that.multipleSelection[item].iOrder)) {
                fee_ids.push(that.multipleSelection[item].iOrder) 
                }
            }
            for (let item in fee_ids) {
                for (let items in that.tableDatas) {
                    if (fee_ids[item] === that.tableDatas[items].iOrder) {
                        feeData.push(JSON.parse(JSON.stringify(that.tableDatas[items])))
                    }
                }
            }
            that.$refs.ExpenseBillPrint.SetfeeData(JSON.parse(JSON.stringify(feeData))).then(res => {
            })
        },
        OneClickTransmission () {
            let that = this
            if (that.multipleSelection.length !== 0) {
                that.$confirm('是否发送账单至客户邮箱？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    that.fullscreenLoading = true
                    // let iOrder = []
                    let fee_ids = []
                    for (let item in that.multipleSelection) {
                        // iOrder.push(JSON.parse(JSON.stringify(that.multipleSelection[item].iOrder)))
                        let iOrderid = JSON.parse(JSON.stringify([]))
                        for (let items in that.tableData) {
                            if (that.multipleSelection[item].iOrder === that.tableData[items].iOrder) {
                                iOrderid.push(JSON.parse(JSON.stringify(that.tableData[items].id)))
                            }
                        }
                        fee_ids.push(JSON.parse(JSON.stringify(iOrderid.join('-'))))
                    }
                    // console.log(fee_ids)
                    let data = {
                        fee_ids: fee_ids.join(',')
                    }
                    data.ADMIN_ID = getAdminId()
                    data.ADMIN_TOKEN = getToken()
                    // row.status = 1
                    // this.fullscreenLoading = true
                    // console.log(fee_ids)
                    this.$store.dispatch('OneClickTransmission', data).then(res => {
                        if (res.flag) {
                            this.$message({
                                type: 'success',
                                message: res.message
                            })
                            this.GetExpenseBillData()
                        } else {
                            this.fullscreenLoading = false
                            this.$message({
                                type: 'warning',
                                message: res.message
                            })
                        }
                    })
                }).catch(() => {
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请选择要发送的账单'
                })
            }
        },
        ImportExpenseBillShow () {
            this.ImportExpenseBillTitle = '导入费用账单'
            this.ImportExpenseBilldialog = true
        },
        BeforeUpload (file) {
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
            const extension = testmsg === 'xls'
            const extension2 = testmsg === 'xlsx'
            const extension3 = testmsg === 'XLS'
            const extension4 = testmsg === 'XLSX'
            if (!extension && !extension2 && !extension3 && !extension4) {
                this.$message({
                    message: '导入文件只能是 xls、xlsx格式!',
                    type: 'warning',
                    offset: this.Height / 2 - 46
                })
                return false
            } else if (extension || extension2 || extension3 || extension4) {
                return file
            }
        },
        Success (response, file, fileList) {
            this.GetExpenseBillData()
            this.ImportExpenseBilldialog = false
        },
        ToVoidExpenseBillShow (data) {
            let row = JSON.parse(JSON.stringify(data))
            this.$confirm('是否删除该账单？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId()
                row.ADMIN_TOKEN = getToken()
                row.status = 1
                this.fullscreenLoading = true
                this.$store.dispatch('ToVoidExpenseBillShow', row).then(res => {
                    if (res.flag) {
                        this.$message({
                            type: 'success',
                            message: res.message
                        })
                        this.GetExpenseBillData()
                    } else {
                        this.fullscreenLoading = false
                        this.$message({
                            type: 'warning',
                            message: res.message
                        })
                    }
                })
            }).catch(() => {
            })
        },
        Export () {
            let that = this
            this.fullscreenLoading = true
            let form = JSON.parse(JSON.stringify(this.form))
            let data = {
                type: form.type,
                company_name: form.company_name,
                status: form.status,
                yearmonth: form.yearmonth,
                limit: this.Size,
                page: this.currentPage,
                isexcel: 1
            }
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            that.$store.dispatch('ExportExpenseBillData', data).then(res => {
                let link = document.createElement('a')
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = '费用账单' // 下载的文件名
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.fullscreenLoading = false
            })
        },
        MoneyInput (value, field) {
            let values = (value.match(/^-?\d*(\.?\d{0,2})/g)[0]) || null
            this.ExpenseBillformData[field] = values
        },
        changecompany () {
            for (let item in this.CompanyList) {
                if (this.CompanyList[item].id === this.ExpenseBillformData.company_id) {
                    this.ExpenseBillformData.company_name = JSON.parse(JSON.stringify(this.CompanyList[item].title))
                    this.ExpenseBillformData.room = JSON.parse(JSON.stringify(this.CompanyList[item].room))
                }
            }
        },
        cancelExpenseBill () {
            this.ExpenseBillDialog = false
            this.Editconfirmloding = false
            this.fullscreens = false
        },
        confirmExpenseBill () {
            let that = this
            this.$refs['ExpenseBillruleform'].validate((valid) => {
                if (valid) {
                    that.Editconfirmloding = true
                    let data = JSON.parse(JSON.stringify(this.ExpenseBillformData))
                    data.ADMIN_ID = getAdminId();
                    data.ADMIN_TOKEN = getToken();
                    data.qijian = data.qijian.join('-')
                    that.$store.dispatch('confirmExpenseBill', data).then(res => {
                        that.Editconfirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.ExpenseBillDialog = false
                            that.fullscreenLoading = true
                            that.GetExpenseBillData()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        AddExpenseBillShow () {
            let data = {
                type: '',
                create_date: '',
                company_id: '',
                company_name: '',
                buildding: '',
                floor: '',
                room: '',
                room1: '',
                room2: '',
                qijian: [],
                sfqj: '',
                num: '',
                amount: '',
                beilv: 1,
                total: '',
                before: '',
                after: '',
                fuwufee: '',
                shou_date: '',
                shou_money: '',
                shou_bank: '',
                bank_name: '',
                bank_no: '',
                shou_fapiao: '',
                fee_name: '',
                remark: '',
                jiezhi: ''
            }
            let date = new Date()
            let dates = this.formatDate('Y-m-d', date)
            data.create_date = JSON.parse(JSON.stringify(dates))
            this.ExpenseBillformData = JSON.parse(JSON.stringify(data))
            this.ExpenseBillDialog = true
            this.titles = '新增账单'
            this.GetTypeList()
            this.GetBankList()
            this.GetBankLists()
            this.GetBankListss()
        },
        EditExpenseBillShow (row) {
            let data = JSON.parse(JSON.stringify(row))
            if (data.shou_date === '0000-00-00') {
                data.shou_date = ''
            }
            if (data.beilv == null || data.beilv === undefined || data.beilv < 1) {
                data.beilv = 1
            }
            this.ExpenseBillformData = {
                id: data.id,
                type: data.type,
                create_date: data.create_date,
                company_id: data.company_id,
                company_name: data.company_name,
                buildding: data.buildding,
                floor: data.floor,
                room: data.room,
                room1: data.room1,
                room2: data.room2,
                qijian: data.qijian.split('-'),
                sfqj: data.sfqj,
                num: data.num,
                amount: data.amount,
                beilv: data.beilv,
                total: data.total,
                before: data.before,
                after: data.after,
                fuwufee: data.fuwufee,
                shou_date: data.shou_date,
                shou_money: data.shou_money,
                shou_bank: data.shou_bank,
                bank_name: data.bank_name,
                bank_no: data.bank_no,
                shou_fapiao: data.shou_fapiao,
                fee_name: data.fee_name,
                remark: data.remark,
                jiezhi: data.jiezhi
            }
            this.ExpenseBillDialog = true
            this.titles = '编辑账单'
            this.GetTypeList()
            this.GetBankList()
            this.GetBankLists()
            this.GetBankListss()
        },
        fullscreenstyles () {
            let style = {}
            if (this.fullscreen === false) {
                style.height = 'auto' 
            } else {
                style.height = 'calc(100vh - 120px)'
            }
            return style
        },
        fullscreenstyle () {
            let style = {}
            if (this.fullscreen === false) {
                style.height = '60vh' 
            } else {
                style.height = 'calc(100vh - 120px)'
            }
            return style
        },
        handleSizeChange(size) {
            this.Size = size
            this.currentPage = 1
            this.fullscreenLoading = true
            this.GetExpenseBillData()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetExpenseBillData()
        },
        Reset () {
            this.form = {
                type: '',
                company_name: '',
                status: '',
                yearmonth: ''
            }
        },
        ConfirmQuery () {
            this.fullscreenLoading = true
            this.GetExpenseBillData()
        },
        OneTouch (index) {
            console.log(index)
            if (index === 1) {
                this.PropertyFee()
            } else if (index === 2) {
                this.LeaseFee()
            }
        },
        LeaseFee () {
            this.OneTouchExpenseBill = true
            this.title = '一键生成租金'
            this.formData = {
                type: '租金',
                month: '',
                year: ''
            }
            let date = new Date()
            let dates = this.formatDate('Y-m', date)
            let year = dates.split('-')[0]
            let month = dates.split('-')[1]
            this.formData.year = year
            this.formData.month = Number(month)
        },
        PropertyFee () {
            this.OneTouchExpenseBill = true
            this.title = '一键生成物业费'
            this.formData = {
                type: '物业费',
                month: '',
                year: ''
            }
            let date = new Date()
            let dates = this.formatDate('Y-m', date)
            let year = dates.split('-')[0]
            let month = dates.split('-')[1]
            this.formData.year = year
            this.formData.month = Number(month)
        },
        cancelOneTouchExpenseBill () {
            this.OneTouchExpenseBill = false
            this.confirmloding = false
            this.fullscreen = false
        },
        confirmOneTouchExpenseBill () {
            let that = this
            this.$refs['ruleform'].validate((valid) => {
                if (valid) {
                    that.confirmloding = true
                    let data = JSON.parse(JSON.stringify(this.formData))
                    data.ADMIN_ID = getAdminId();
                    data.ADMIN_TOKEN = getToken();
                    that.$store.dispatch('confirmOneTouchExpenseBill', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.OneTouchExpenseBill = false
                            that.fullscreenLoading = true
                            that.GetExpenseBillData()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        GetExpenseBillData () {
            let that = this
            let form = JSON.parse(JSON.stringify(this.form))
            let data = {
                type: form.type,
                company_name: form.company_name,
                status: form.status,
                yearmonth: form.yearmonth,
                limit: this.Size,
                page: this.currentPage,
                fee_type: 1
            }
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            that.$store.dispatch('GetExpenseBillData', data).then(res => {
                this.visible = false
                let data = JSON.parse(JSON.stringify(res.data))
                let datas = []
                for (let item in data) {
                    if (data[item].son.length !== 0) {
                        for (let items in data[item].son) {
                            let obj = JSON.parse(JSON.stringify(data[item].son[items]))
                            // obj.company_name = JSON.parse(JSON.stringify(data[item].company_name))
                            // obj.room = JSON.parse(JSON.stringify(data[item].room))
                            obj.iOrder = JSON.parse(JSON.stringify(Number(item)))
                            datas.push(JSON.parse(JSON.stringify(obj)))
                        }
                    }
                }
                // console.log(datas)
                let tableData = JSON.parse(JSON.stringify(datas))
                this.tableData = tableData
                for (let item in data) {
                    if (data[item].son.length !== 0) {
                        data[item].iOrder = JSON.parse(JSON.stringify(Number(item)))
                    }
                }
                this.tableDatas = JSON.parse(JSON.stringify(data))
                this.getSpanArr(this.tableData)
                this.total = res.something
                this.fullscreenLoading = false
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    keyword: query,
                    room: '',
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                    status: 1
                }
                this.$store.dispatch('CompanyListShow', data).then(res => {
                    this.CompanyList = res.data
                    this.loading = false
                })
            } else {
                this.loading = true
                let data = {
                    keyword: '',
                    room: '',
                    limit: 10000,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken()
                }
                this.$store.dispatch('CompanyListShow', data).then(res => {
                    this.CompanyList = res.data
                    this.loading = false
                })
            }
        },
        GetCompanyList () {
            let data = {
                keyword: '',
                room: '',
                limit: 10000,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('CompanyListShow', data).then(res => {
                this.CompanyList = res.data
            })
        },
        GetTypeList () {
            let data = {
                PK_EY_Enum: "02e9cc26f999da546ea8a342s12ffd3c"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.TypeList = JSON.parse(JSON.stringify(res.data))
            })
        },
        GetBankList () {
            let data = {
                PK_EY_Enum: "02e9cc26f999da5423223aeb12ffbfd3c"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.BankList = JSON.parse(JSON.stringify(res.data))
            })
        },
        GetBankLists () {
            let data = {
                PK_EY_Enum: "02e9cc26f999da5423223aeb12ffbfd3c"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                let datas = JSON.parse(JSON.stringify(res.data))
                for (let item in datas) {
                    let name = datas[item].cName.replace(/，/ig, ',')
                    datas[item].name = name.split(',')[0]
                    datas[item].no = name.split(',')[1]
                }
                this.BankLists = JSON.parse(JSON.stringify(datas))
            })
        },
        GetBankListss () {
            let data = {
                PK_EY_Enum: "02e9cc26f999da5423223aeb12ffbfd3c"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.BankListss = JSON.parse(JSON.stringify(res.data))
            })
        },
        /**
         * 补零
         * @param str
         * @param length
         * @param after
         * @returns {*}
         */
        zeroFill (str, length, after) {
            str += ''
            if (str.length >= length) {
            return str
            }
            let _str = ''
            let _ret = ''
            for (let i = 0; i < length; i++) {
            _str += '0'
            }
            if (after || typeof after === 'undefined') {
            _ret = (_str + '' + str).substr(length * -1)
            } else {
            _ret = (str + '' + _str).substr(0, length)
            }
            return _ret
        },
        /**
         * 时间戳转时间格式
         * @param format
         * @param v
         * @returns {string}
         */
        formatDate (format, v) {
            if (format === '') {
            format = 'Y-m-d H:i:s'
            }
            let dateObj
            if (v instanceof Date) {
            dateObj = v
            } else {
            if (typeof v === 'undefined') {
                v = new Date().getTime()
            } else if (/^(-)?\d{1,10}$/.test(v)) {
                v = v * 1000
            } else if (/^(-)?\d{1,13}$/.test(v)) {
                v = v * 1
            } else if (/^(-)?\d{1,14}$/.test(v)) {
                v = v * 100
            } else if (/^(-)?\d{1,15}$/.test(v)) {
                v = v * 10
            } else if (/^(-)?\d{1,16}$/.test(v)) {
                v = v * 1
            } else {
                return v
            }
            dateObj = new Date(v)
            }
            //
            format = format.replace(/Y/g, dateObj.getFullYear())
            format = format.replace(/m/g, this.zeroFill(dateObj.getMonth() + 1, 2))
            format = format.replace(/d/g, this.zeroFill(dateObj.getDate(), 2))
            format = format.replace(/H/g, this.zeroFill(dateObj.getHours(), 2))
            format = format.replace(/i/g, this.zeroFill(dateObj.getMinutes(), 2))
            format = format.replace(/s/g, this.zeroFill(dateObj.getSeconds(), 2))
            return format
        },
    },
    created() {
        this.fullscreenLoading = true
        this.GetCompanyList()
        this.GetExpenseBillData()
        this.GetTypeList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    },
    components: {
        ExpenseBillPrint
    }
};
</script>

<style>
.HydropowerExpenseBill {
    width: 100%;
}
.HydropowerExpenseBill .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.HydropowerExpenseBill .el-header .el-row .el-col h2 {
    text-align: center;
}
.HydropowerExpenseBill .el-header .el-row .el-col {
    text-align: center;
}
.HydropowerExpenseBill .el-header .el-row .el-col:last-child {
    text-align: right;
}
.HydropowerExpenseBill .el-header .el-row .el-col .el-dropdown {
    margin-right: 10px;
}
/* .HydropowerExpenseBill .el-header .el-row .el-col .el-dropdown {
    margin-right: 10px;
} */
.HydropowerExpenseBill .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.queryExpenseBill .el-select, .queryExpenseBill .el-form-item__content .el-date-editor {
    width: 100%;
}
.HydropowerExpenseBill .el-main .AssignPersonneldialog .el-select {
    width: 100%;
}
.HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body {
    padding: 0px;
    overflow: hidden;
}
.HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item {
    display: inline-block;
    width: 100%;
}
.HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item .el-select,.ExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item .el-date-editor {
    width: 100%;
}
.HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item {
    width: 100%;
}
/* .HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item:nth-child(1), .HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item:nth-child(2), .HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item:nth-last-child(1), .HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item:nth-last-child(2), .HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item:nth-last-child(3), .HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .el-form-item:nth-last-child(4) {
    width: 100%;
} */
.HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .el-form .money input {
    text-align: right;
}
.HydropowerExpenseBill .el-main .OneTouchExpenseBill .el-dialog__body .ExpenseBillData {
    padding: 20px 20px;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body {
    padding: 0px;
    overflow: hidden;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item {
    display: inline-block;
    width: 100%;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item .el-select,.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item .el-date-editor {
    width: 100%;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item {
    width: 50%;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item:nth-child(1), .HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item:nth-child(10), .HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item:nth-child(15), .HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .el-form-item:nth-child(20) {
    width: 100%;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .el-form .money input {
    text-align: right;
}
.HydropowerExpenseBill .el-main .ExpenseBillDialog .el-dialog__body .ExpenseBillDialogData {
    padding: 20px 20px;
    overflow: auto;
}
.HydropowerExpenseBill .el-main .ImportExpenseBilldialog input {
    display: none !important;
}
.HydropowerExpenseBill .el-main .ImportExpenseBilldialog a {
    display: block;
    width: 56px;
    margin-left: 20px;
    color: #1989fa;
}
</style>
